<template>
  <a
    class="frisbuy-product-item"
    @click="($event) => openLink($event, product.link)"
  >
    <div class="frisbuy-product-item__image">
      <LikeButton
        @click.stop="() => likeButtonClick()"
        :isLiked="isLiked"
        :productArticle="product.sku?.vendorCode"
      />
      <div class="frisbuy-similar-title" v-if="product.isSimilar">
        {{ popupText.similarGood }}
      </div>
      <GalleryBlur v-if="!contentIsLoaded" style="z-index: 3;" />
      <img
        :src="getDomainSubstitute(product.sku?.picUrl)"
        @load="loadImageHandler"
        @error="errorImageHandler"
      />

      <div
        v-if="isShowPin"
        :class="{
          'frisbuy-marker': true,
          'frisbuy-marker-hover': product.hover,
        }"
        :style="{ color: pinColor }"
      >
        <!-- <span>{{ index + 1 }}</span> -->
      </div>
    </div>

    <div class="frisbuy-product-item__info">
      <div class="frisbuy-product-item__title">
        <span>
          {{ product.title }}
        </span>
      </div>
      <div v-if="product.sku?.price" class="frisbuy-product-item__price">
        <span class="frisbuy-product-item__price--actual">
          {{ product.sku.price }}
          <span class="frisbuy-product-item__currency-symbol"> ₽ </span>
        </span>
        <div
          v-if="product.sku?.priceOld"
          class="span frisbuy-product-item__price--old"
        >
          {{ product.sku.priceOld }}
          <span class="frisbuy-product-item__currency-symbol"> ₽ </span>
        </div>
      </div>

      <button class="frisbuy-product-item__buy-button">
        <svg
          width="14"
          height="18"
          viewBox="0 0 14 18"
          version="1.1"
          style="fill: none"
        >
          <path
            d="m 0.5,5.5 h 13 V 16 c 0,0.3978 -0.158,0.7794 -0.4393,1.0607 C 12.7794,17.342 12.3978,17.5 12,17.5 H 2 C 1.60218,17.5 1.22064,17.342 0.93934,17.0607 0.658035,16.7794 0.5,16.3978 0.5,16 Z"
            id="path2"
            style="stroke: #6e6e6e"
          />
          <path
            d="m 0.5,5.5 h 13 V 16 c 0,0.3978 -0.158,0.7794 -0.4393,1.0607 C 12.7794,17.342 12.3978,17.5 12,17.5 H 2 C 1.60218,17.5 1.22064,17.342 0.93934,17.0607 0.658035,16.7794 0.5,16.3978 0.5,16 Z"
            id="path4"
            style="stroke: #6e6e6e"
          />
          <path
            d="M 10,7.5 V 3.533 C 10.0043,2.73301 9.69065,1.96408 9.12806,1.39531 8.56548,0.82654 7.80003,0.5045 7.00004,0.5 6.20005,0.5045 5.4346,0.82654 4.87202,1.39531 4.30944,1.96408 3.99579,2.73301 4.00004,3.533 V 7.5"
            id="path6"
            style="
              stroke: #6e6e6e;
              stroke-linecap: round;
              stroke-linejoin: round;
            "
          />
        </svg>
      </button>
    </div>
  </a>
</template>

<style scoped lang="scss">
@import "@/gallery/mixins.scss";

* {
  box-sizing: border-box;
}

a,
a:hover,
a:visited,
a:active {
  color: #525252;
  text-decoration: none;
}

.frisbuy-product-item {
  display: flex;
  flex-direction: column;

  width: 213px;
  height: 315px;
  min-width: fit-content;
  font-family: inherit;

  .frisbuy-similar-title {
    background-color: #9d9c9d;
    color: #FFF;
    border-radius: 3px;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 2px 5px;
    font-size: 9px;
    font-weight: bold;
    text-transform: uppercase;
    margin: 0 0 10px 10px;
    z-index: 1;
  }

  .frisbuy-product-item__image {
    $likeButtonTop: 6px;
    $likeButtonRight: 7px;

    display: flex;
    position: relative;
    width: 100%;
    aspect-ratio: 1 / 1;

    background-color: #e6e6e6;

    img {
      position: absolute;
      inset: 0;

      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .frisbuy-like-button {
      position: absolute;
      inset: $likeButtonTop $likeButtonRight auto auto;

      width: 30px;

      margin: 0;
    }

    .frisbuy-marker {
      border: none;
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
      inset: $likeButtonTop auto auto $likeButtonRight;
    }
  }

  .frisbuy-product-item__info {
    $buyButtonWidth: 40px;
    $textMarginRight: 16px;

    display: flex;
    flex-wrap: nowrap;

    flex-direction: column;
    position: relative;

    font-size: 14px;

    margin-top: 10px;

    & > * {
      width: calc(100% - ($buyButtonWidth + $textMarginRight));
    }

    .frisbuy-product-item__title {
      font-size: 0.86em;

      span {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    .frisbuy-product-item__price {
      display: flex;
      flex-direction: row;
      width: fit-content;
      height: 25%;

      font-size: 1em;
      white-space: nowrap;

      margin-top: 8px;

      &--actual {
        color: #8f1837;
      }

      &--old {
        text-decoration: line-through;
        color: #96999c;

        margin-left: 12px;
      }
    }

    .frisbuy-product-item__buy-button {
      display: block;
      position: absolute;
      top: 0;
      right: 0;

      flex: 0 0 auto;

      width: $buyButtonWidth;
      height: $buyButtonWidth;
      aspect-ratio: 1 / 1;
      border: solid #00000060 1px;
      background-color: transparent;

      cursor: pointer;

      top: 50%;
      right: 0;
      transform: translateY(-50%);

      margin: auto 0 auto 0;
      padding: 0;

      svg {
        display: block;
        width: 15px;

        margin: auto;
      }
    }
  }
}

// media queries
.frisbuy-product-item {
  container-type: inline-size;

  @container (max-width: 172px) {
    .frisbuy-product-item__info {
      .frisbuy-product-item__price {
        font-size: 0.8em;

        &--old {
          @container (max-width: 172px) {
            margin-left: 4px;
          }
        }
      }

      .frisbuy-product-item__buy-button {
        width: 24px;
        height: 24px;

        svg {
          width: 10px;
        }
      }
    }
  }
}
</style>

<script lang="ts">
// Modules
import { PropType, defineComponent } from "vue";
// Components
import LikeButton from "./LikeButton.vue";
import GalleryBlur from "@/components/popup/GalleryBlur.vue";
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";
// Types
import { IPostLinkInList } from "@/gallery/interfaces";

export default defineComponent({
  components: { LikeButton, GalleryBlur },

  emits: {
    clickProduct(product: IPostLinkInList) {
      return product;
    },

    like: null,
  },

  props: {
    product: {
      type: Object as PropType<IPostLinkInList>,
      required: true,
    },

    linkTarget: {
      type: String as PropType<"_self" | "_blank" | "_parent" | "_top">,
      required: false,
      default: "_self",
    },

    isLiked: {
      type: Boolean,
      required: false,
      default: false,
    },

    isShowPin: {
      type: Boolean,
      required: false,
      default: false,
    },
    pinColor: {
      type: String,
      required: false,
      default: "unset",
    },
    
    popupText: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      contentIsLoaded: false,
    };
  },

  created() {
    if (!this.product.sku || !this.product.sku.picUrl) {
      this.contentIsLoaded = true;
    }
  },

  methods: {
    openLink($event: MouseEvent, link: string) {
      window.open(link, this.linkTarget);

      this.$emit("clickProduct", this.product);
    },

    getDomainSubstitute(srcUrl: string): string {
      return DomainSubstitute(srcUrl);
    },

    loadImageHandler() {
      this.contentIsLoaded = true;
    },

    errorImageHandler(e: Event) {
      MediaCatcher(e, 2, widgetTypes.SHOP_THE_LOOK);
    },

    likeButtonClick() {
      this.$emit("like");
    },
  },
});
</script>
